<template>
  <!-- 🌿 Banner -->
  <section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <div class="bg-overlay bg-dark opacity-6"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 🔙 Botón volver -->
  <div class="container mb-0">
    <div class="row">
      <div class="col-12">
        <button @click="goBack" class="btn btn-green btn-sm rounded-pill">
          <i class="fas fa-arrow-left me-2"></i> Volver atrás
        </button>
      </div>
    </div>
  </div>

  <!-- 📄 Detalle -->
  <section>
    <div class="container" data-sticky-container>
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-success"></div>
        <p class="mt-3">Cargando publicación...</p>
      </div>

      <div v-else-if="error" class="alert alert-danger text-center">
        {{ error }}
      </div>

      <div v-else-if="publication" class="row g-4 g-sm-5">
        <!-- 📚 Columna lateral -->
        <div class="col-xl-4">
          <div data-sticky data-margin-top="80" data-sticky-for="992">
            <div class="row justify-content-center">
              <div class="col-md-8 col-xl-12">
                <div class="card shadow">
                  <div class="rounded-3">
                    <img
                      :src="
                        publication.image_path ||
                        '/assets/images/placeholder.jpg'
                      "
                      class="card-img-top"
                      alt="Imagen de la publicación"
                    />
                  </div>
                  <div class="card-body pb-3">
                    <div class="text-center">
                      <!--<button
                        @click="
                          downloadPublication(publication.id, publication.title)
                        "
                        class="btn btn-success-soft mb-2"
                        style="width: 100%"
                        :disabled="isDownloading"
                      >
                        <span
                          v-if="isDownloading"
                          class="spinner-border spinner-border-sm me-2"
                        ></span>
                        <i v-else class="bi bi-download m-2"></i>
                        {{ isDownloading ? "Descargando..." : "DESCARGAR" }}
                      </button>-->
                    </div>

                    <div class="row mb-3 mt-3">
                      <div class="col-md-12">
                        <ul class="list-group list-group-borderless datos-publicacion">
                          <li
                            class="list-group-item px-0"
                            v-if="publication.published"
                          >
                            <span class="h6 fw-light">
                              <i
                                class="bi fa-fw bi-calendar-fill text-primary me-2"
                              ></i>
                              Publicado el:
                            </span>
                            <span class="h6">{{
                              formatDate(publication.published)
                            }}</span>
                          </li>

                          <li
                            class="list-group-item px-0"
                            v-if="publication.pages"
                          >
                            <span class="h6 fw-light">
                              <i
                                class="fas fa-fw fa-book text-primary me-2"
                              ></i>
                              Páginas:
                            </span>
                            <span class="h6">{{ publication.pages }}</span>
                          </li>

                          <li
                            class="list-group-item px-0"
                            v-if="publication.size"
                          >
                            <span class="h6 fw-light">
                              <i
                                class="fas fa-fw fa-font text-primary me-2"
                              ></i>
                              Tamaño:
                            </span>
                            <span class="h6">{{ publication.size }}</span>
                          </li>

                          <li
                            class="list-group-item px-0"
                            v-if="publication.language"
                          >
                            <span class="h6 fw-light">
                              <i
                                class="bi fa-fw bi-translate text-primary me-2"
                              ></i>
                              Idioma:
                            </span>
                            <span class="h6">{{ publication.language }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 🧾 Contenido -->
        <div class="col-xl-8">
          <h1 class="mb-4">{{ publication.title }}</h1>

          <h4>Descripción</h4>
          <div class="card border">
            <div class="card-body detalle-noticia">
              <p v-html="publication.detail"></p>
            </div>
          </div>

          <!--<p class="mt-3">
            <strong>Publicado:</strong>
            <span class="texto_azul">{{
              formatDate(publication.published)
            }}</span>
          </p>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { usePublicationDetailStore } from "@/modules/posts/stores/publicationDetail";
import apiClient from "@/plugins/axios";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const publicationStore = usePublicationDetailStore();
    const { publication, loading, error } = storeToRefs(publicationStore);
    const isDownloading = ref(false);

    const goBack = () => {
      router.push({ name: "posts-home" });
    };

    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date + "T00:00:00");
      return d.toLocaleDateString("es-BO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    const downloadPublication = async (id, title) => {
      isDownloading.value = true;
      try {
        const response = await apiClient.get(`/download-publication/${id}`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${title}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch {
        alert("Error al descargar la publicación.");
      } finally {
        isDownloading.value = false;
      }
    };

    onMounted(() => {
      publicationStore.fetchPublicationDetail(route.params.id);
    });

    return {
      publication,
      loading,
      error,
      formatDate,
      downloadPublication,
      isDownloading,
      goBack,
    };
  },
};
</script>

<style scoped>
.texto_azul {
  color: #003366;
  font-weight: 600;
}
.card-body p{
  font-family: "Montserrat";
}
h1{
font-family: "Merriweather";
}
h4{
font-family: "Merriweather";
}
.datos-publicacion li span{
  font-family: "Montserrat";
}
.detalle-noticia{
  text-align: justify;
}
</style>
